import { ReactNode } from 'react';

interface BadgeProps {
  label?: string;
  color: 'green' | 'red' | 'blue' | 'gray' | 'orange';
  icon?: ReactNode;
  position?:
    | 'top-right'
    | 'top-left'
    | 'bottom-right'
    | 'bottom-left'
    | 'corner-ribbon';
  className?: string;
}

const colorVariants = {
  green: 'bg-green-100 text-green-800',
  red: 'bg-red-100 text-red-800',
  blue: 'bg-blue-100 text-linko-light',
  gray: 'bg-gray-100 text-gray-800',
  orange: 'bg-orange-100 text-orange-800',
};

const positionVariants = {
  'top-right': 'absolute top-2 right-2',
  'top-left': 'absolute top-2 left-2',
  'bottom-right': 'absolute bottom-2 right-2',
  'bottom-left': 'absolute bottom-2 left-2',
  'corner-ribbon': 'absolute -right-1 -top-1 transform rotate-12 z-10',
};

export const Badge = ({
  label,
  color,
  icon,
  position,
  className = '',
}: BadgeProps) => {
  const positionClass = position ? positionVariants[position] : '';
  const isCornerRibbon = position === 'corner-ribbon';

  return (
    <div
      className={`flex w-fit select-none items-center justify-center gap-1 ${isCornerRibbon ? 'px-4 py-1 shadow-md' : 'rounded-full px-3 py-1 shadow-sm'} text-xs font-medium ${colorVariants[color]} ${positionClass} ${className}`}
    >
      {icon && (
        <span className="flex size-4 items-center justify-center">{icon}</span>
      )}
      {label && <span>{label}</span>}
    </div>
  );
};
